<template>
  <v-container>
    <v-card-text v-if="loading" class="text-center py-10">
      <v-progress-circular indeterminate color="primary"/>
    </v-card-text>

    <v-alert
        v-else-if="error"
        type="error"
        class="text-center"
    >
      {{ error }}
    </v-alert>

    <v-alert
        v-else-if="bewertungen.length === 0"
        type="info"
        class="text-center"
    >
      Sie haben noch keine Unternehmen bewertet.
    </v-alert>

    <v-row v-else>
      <v-col
          v-for="bewertung in bewertungen"
          :key="bewertung.id"
          cols="12"
      >
        <v-card>
          <v-card-text>
            <v-row align="center">
              <v-col>
                <p class="font-weight-bold mb-1">
                  {{ bewertung.firmaName }}
                </p>
              </v-col>
              <v-col cols="auto">
                <v-btn
                    color="error"
                    variant="outlined"
                    size="small"
                    :loading="deletingId === bewertung.id"
                    @click="openDeleteDialog(bewertung)"
                    style="text-transform: none !important;"
                >
                  <i class="fa-solid fa-trash mr-2"/>
                  Löschen
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center" no-gutters>
              <v-rating
                  :model-value="bewertung.sterne"
                  color="amber-darken-2"
                  density="compact"
                  readonly
                  size="small"
              />
              <span class="text-caption ml-2">
                {{ formatDate(bewertung.erstelltAm) }}
              </span>
            </v-row>
            <p v-if="bewertung.text" class="my-4">
              {{ bewertung.text }}
            </p>
            <v-card
                v-if="bewertung.antwortUnternehmen"
                variant="tonal"
            >
              <v-card-text>
                <p class="font-weight-bold mb-1">Antwort des Unternehmens</p>
                <p class="mb-0">{{ bewertung.antwortUnternehmen }}</p>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="deleteDialog" max-width="460">
      <v-card>
        <v-card-title>Bewertung löschen?</v-card-title>
        <v-card-text>
          Möchten Sie Ihre Bewertung für {{ deleteTarget?.firmaName || 'dieses Unternehmen' }} wirklich löschen?
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              variant="text"
              @click="closeDeleteDialog"
              style="text-transform: none !important;"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="error"
              :loading="deletingId === deleteTarget?.id"
              @click="deleteReview"
              style="text-transform: none !important;"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  name: 'AccountReviews',

  data() {
    return {
      bewertungen: [],
      loading: false,
      error: '',
      deleteDialog: false,
      deleteTarget: null,
      deletingId: null
    }
  },

  computed: {
    ...mapGetters(['jwt'])
  },

  mounted() {
    this.loadReviews()
  },

  methods: {
    async loadReviews() {
      this.loading = true
      this.error = ''

      try {
        const response = await axios.get('/api/bewertungen/me', {
          headers: {
            'x-auth-token': this.jwt
          }
        })

        if (!response.data?.ok) {
          this.error = response.data?.error || 'Ihre Bewertungen konnten nicht geladen werden.'
          return
        }

        this.bewertungen = response.data.bewertungen || []
      } catch (error) {
        this.error = error.response?.data?.error || 'Ihre Bewertungen konnten nicht geladen werden.'
      } finally {
        this.loading = false
      }
    },
    openDeleteDialog(bewertung) {
      this.deleteTarget = bewertung
      this.deleteDialog = true
    },
    closeDeleteDialog() {
      this.deleteDialog = false
      this.deleteTarget = null
    },
    async deleteReview() {
      if (!this.deleteTarget?.firmaId) {
        return
      }

      this.deletingId = this.deleteTarget.id

      try {
        const response = await axios.delete(`/api/firmas/${this.deleteTarget.firmaId}/bewertungen`, {
          headers: {
            'x-auth-token': this.jwt
          }
        })

        if (!response.data?.ok) {
          this.error = response.data?.error || 'Die Bewertung konnte nicht gelöscht werden.'
          return
        }

        this.bewertungen = this.bewertungen.filter(item => item.id !== this.deleteTarget.id)
        this.closeDeleteDialog()
      } catch (error) {
        this.error = error.response?.data?.error || 'Die Bewertung konnte nicht gelöscht werden.'
      } finally {
        this.deletingId = null
      }
    },
    formatDate(value) {
      if (!value) {
        return ''
      }

      return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(new Date(value))
    }
  }
}
</script>
